import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class MyFavoritesService {

  constructor(private httpClient: HttpClient) { }

  getFavoriteDocuments(isActive: boolean) : Observable<any>{
    return this.httpClient.get(ApiConstants.FavoriteDocumentDetails + isActive);
  }
}
